export default __webpack_public_path__ + "static/media/account_circle_black_24dp (2).10c8a50e.svg";